import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';

/*
  Generated class for the NotificacionesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NotificacionesProvider {

  private api: string = "";

  constructor(public http: Http, public global:GlobalProvider) {
    this.api = this.global.api;
    console.log('Hello NotificacionesProvider Provider');
  }

  // Elimina un congreso
  public delete(clave): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "notificaciones",
      "clave": clave,
    };

    return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public insert(congreso,registro): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    registro.clavecongreso = congreso.clave;
    registro.guid_enlace = this.newGuid();
    let parametros ={
      "token":this.global.token,
      "tabla": "notificaciones",
      "parametros": registro,
      "clavecongreso":congreso.clave 
    };
   console.log(parametros);
    
    return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
      (response) => {
        console.log(response);
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Actualiza una notificacion
  public update(congreso,registro): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "notificaciones",
      "clave": registro.clave,
      "parametros": registro,
      "clavecongreso":congreso.clave 
    };
    console.log(parametros);
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        console.log(response);
        var respuesta = response.json();
         
         return respuesta[0];
      }
    ).catch(this.handleError);
  }


  // Devuelve todos los poenentes de un congreso
  public all(clavecongreso): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "tabla":"notificaciones",
      "campofiltro":"clavecongreso",
      "valorfiltro": clavecongreso, 
      "campoorden": "fechapublicacion desc"
    };
   
    return this.http.post(this.api+"apigen/list.php", parametros, options).map(
      (response) => {
      
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public busca_notificacion(clave): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "clave_notificacion":clave
    };
   
    return this.http.post(this.api+"notificaciones/listafiltro.php", parametros, options).map(
      (response) => {
      
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  // Devuelve todos los poenentes de un congreso
  public pendientes(clavecongreso): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "clavecongreso":clavecongreso,
      "dispositivo": this.global.guid
    };
 
    return this.http.post(this.api+"congresos/notificacionespendientes.php", parametros, options).map(
      (response) => {
       
        return response.json();
        
      }
    ).catch(this.handleError);
  }

 // Devuelve todos los poenentes de un congreso
 public envia(notificacion) {
 
  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

 
 
}
public allnotificaciones(clavecongreso): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
     "dispositivo": this.global.guid,
     "clavecongreso":clavecongreso
  };
  
   return this.http.post(this.api+"notificaciones/allnotificaciones.php", parametros, options).map(
    (response) => {
    
      return response.json(); 
    }
  ).catch(this.handleError);
}
// Acuse de lectura de una notificacion
public notificacionesdispositivo(clavecongreso): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
     "dispositivo": this.global.guid,
     "clavecongreso":clavecongreso
  };
  
   return this.http.post(this.api+"notificaciones/notificacionesdispositivo.php", parametros, options).map(
    (response) => {
    
      return response.json(); 
    }
  ).catch(this.handleError);
}
public notificacionesdispositivopaginado(clavecongreso,pagina): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
     "dispositivo": this.global.guid,
     "clavecongreso":clavecongreso,
     "pagina":pagina
  };
  console.log(parametros);
   return this.http.post(this.api+"notificaciones/notificacionesdispositivopaginado.php", parametros, options).map(
    (response) => {
    
      return response.json(); 
    }
  ).catch(this.handleError);
}


public carganotificacion(clavenotificacion): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
    "dispositivo": this.global.guid,
     "clavenotificacion":clavenotificacion
  };
console.log(parametros);
  
   return this.http.post(this.api+"notificaciones/notificacion.php", parametros, options).map(
    (response) => {
      var respuesta = response.json();
      
      return respuesta[0];
    }
  ).catch(this.handleError);
}
public carganotificacionedit(clavenotificacion): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
    "dispositivo": this.global.guid,
     "clavenotificacion":clavenotificacion
  };
console.log(parametros);
  
   return this.http.post(this.api+"notificaciones/notificacionedicion.php", parametros, options).map(
    (response) => {
      var respuesta = response.json();
      
      return respuesta[0];
    }
  ).catch(this.handleError);
}

public lista_notificacionespendientes(clavecongreso): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
    "dispositivo": this.global.guid,
     "clavecongreso":clavecongreso
  };
  console.log(parametros);
  
   return this.http.post(this.api+"notificaciones/numeronotificacionespendientes.php", parametros, options).map(
    (response) => {
      console.log(response);
      var respuesta = response.json();
      
      return respuesta[0];
    }
  ).catch(this.handleError);
}

// Acuse de lectura de una notificacion
public notificacionrecibida(clavenotificacion): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
    "tabla": "notificaciones",
    "dispositivo": this.global.guid,
    "clavenotificacion": clavenotificacion
  };
 
 
  return this.http.post(this.api+"notificaciones/notificacionrecibida.php", parametros, options).map(
    (response) => {
      var respuesta = response.json();
      
       return respuesta[0];
    }
  ).catch(this.handleError);
}

  // Acuse de lectura de una notificacion
  public notificacionlectura(clavenotificacion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "notificaciones",
      "dispositivo": this.global.guid,
      "clavenotificacion": clavenotificacion
    };
   
    return this.http.post(this.api+"congresos/notificacionlectura.php", parametros, options).map(
      (response) => {
        
        return response.json(); 
      }
    ).catch(this.handleError);
  }


  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}




// WEBPACK FOOTER //
// ./src/providers/notificaciones/notificaciones.ts